import React from 'react';

const LoggedOut = React.memo(({caption, isRequired, ...props}) => {         
    return (                        
        <React.Fragment></React.Fragment> 
    );     
});  

export default LoggedOut; 